import React, { FC, PropsWithChildren } from 'react'
import CheckCircle from '@mui/icons-material/CheckCircle'
import Circle from '@mui/icons-material/Circle'

interface ValidationCheckProps {
  valid: boolean
}

const ValidationCheck: FC<PropsWithChildren<ValidationCheckProps>> = ({ children, valid }) => {
  return (
    <div className="tw:flex tw:items-center tw:gap-2">
      {valid ? (
        <CheckCircle className="tw:!size-4 tw:text-green-700" />
      ) : (
        <Circle className="tw:!size-4 tw:text-neutrals-400" />
      )}
      <div>{children}</div>
    </div>
  )
}

export default ValidationCheck
